import axios from "axios";
import {encryptData, decryptData, getVerificationToken, getGuid } from "../utils/Utils";



class ApiServiceClient {
  constructor(baseURL) {
    this.api = axios.create({
      baseURL,
      timeout: 10000,
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Request Interceptor
    this.api.interceptors.request.use(
      (config) => {
        const authToken = getVerificationToken();
        console.log("authToken data:", authToken);

        if (authToken) {
          config.headers["Authorization"] = `${authToken}`;
        }

        // Encrypt request body for `POST`, `PUT`, `PATCH`
        if (["post", "put", "patch"].includes(config.method)) {
          console.log("Plain Body before extra param:", config.data);

          // Add extra parameter
          config.data = {
            ...config.data,
            corporate: "grafcare"
          };

          console.log("Plain Body with extra param:", config.data);

          const jsonString = JSON.stringify(config.data);
          const encryptedText = encryptData(jsonString);
          const encodedEncryptedText = encodeURIComponent(encryptedText);

          config.data = { encParams: encodedEncryptedText };

          console.log("Encrypted Body:", config.data);
        }

        return config;
      },
      (error) => {
        console.error("Request Error:", error.message || error);
        return Promise.reject(error);
      }
    );

    // Response Interceptor
    this.api.interceptors.response.use(
      (response) => {
        try {
          // console.error("interceptors:", response.data);

          response.data = response.data.replace(/[\n\r]/g, "").trim();
          response.data = JSON.parse(decryptData(response.data));

          console.log("Plain Response:", response.data);
        } catch (error) {
          console.error("Response Decryption Failed:", error);
          return Promise.reject(error);
        }

        const endpoint = response.config.url;
        console.log("endpoint:", endpoint);

        return response.data;
      },
      (error) => {
        if (error.response) {
          console.error("API Error Response:", {
            url: error.response.config.url,
            method: error.response.config.method,
            status: error.response.status,
            data: error.response.data,
          });

          // if (error.response.status === 401 || error.response.status === 404) {
          //   window.location.href = "/logout";
          // }
        } else {
          console.error("API Error:", error.message || error);
        }
        return Promise.reject(error);
      }
    );
  }

  async post(url, data = {}, params = {}) {
    try {
      return await this.api.post(url, data, { params });
    } catch (error) {
      console.error(`POST Error at ${url}:`, error.message || error);
      throw error;
    }
  }

  async get(url, params = {}) {
    try {
      return await this.api.get(url, { params });
    } catch (error) {
      console.error(`GET Error at ${url}:`, error.message || error);
      throw error;
    }
  }
}

// const commonService = new ApiServiceClient("https://pwaapi.goqii.com/");

const commonService = new ApiServiceClient("https://pwaapi.goqii.com/");


export default commonService;
